import Home from '../pages/index.vue'

const routers = [
    {
        path: '/src/pages/index',
        name: 'home',
        component: Home
    }
]
export default routers


// WEBPACK FOOTER //
// ./src/router/routers.js